import { React, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../Context/LanguageContext';

import { ReactComponent as DeleteSvg } from '../../../image/Delete.svg';

import NoticeDeleteModal from './NoticeDeleteModal';

const NoticeInfo = (props) => {
  const { data, index, clickFn, refreshFn } = props;

  const { t } = useLanguage();

  const [isDeleteHovered, setIsDeleteHovered] = useState(false);
  const [deleteClick, setDeleteClick] = useState(false);

  return (
    <TopLevelWrapper onClick={() => clickFn(index)} $isDeleteHovered={isDeleteHovered}>
      {deleteClick && <NoticeDeleteModal noticeId={data.noticeId} exitClickFn={() => setDeleteClick(false)} onDeleteSuccess={refreshFn} />}
      <TextWrapper>
        <Title>{data.title}</Title>
      </TextWrapper>
      <TextWrapper>
        <CommentCountText>{t('main.notice.commentCount', { count: data.commentCount + data.replyCount })}</CommentCountText>
        <CreatedDate>{moment(data.createdDate).format(t('noticePage.dateFormatShort'))}</CreatedDate>
        <DeleteIcon
          onMouseEnter={() => setIsDeleteHovered(true)}
          onMouseLeave={() => setIsDeleteHovered(false)}
          onClick={(e) => { e.stopPropagation(); setDeleteClick(true); }}
        />
      </TextWrapper>
    </TopLevelWrapper>
  )
}

export default NoticeInfo;

const DeleteIcon = styled(DeleteSvg)`
  width: 0;
  height: 16px;

  flex-shrink: 0;
  overflow: hidden;

  margin-left: -20px;

  color: ${props => props.theme.line};

  opacity: 0;

  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out, color 0.3s ease-in-out, margin-left 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.pointRed};
    }
  }
`;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-itmes: center;

  padding: 7px 10px;

  box-sizing: border-box;
  width: 100%;
  height: 35px;

  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 5px;
  background-color: ${props => props.$isDeleteHovered ? props.theme.pointRedAlpha50 : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.primaryAlpha50};

      ${DeleteIcon} {
        width: 16px;
        opacity: 1;
        margin-left: 0;
      }
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 20px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.text};
`;

const CommentCountText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.text};
`;

const CreatedDate = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  width: 93px;

  text-align: right;

  color: ${props => props.theme.text};
`;
